import React from 'react';
import { Box, ButtonBase, Dialog, IconButton, Typography } from '@material-ui/core';
import { CloseIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import { baseCassConfirm } from '../baseCss';
import { bedP as P } from '../../../bsApp';

export default function Updatetoavailable({ allData, open, closePop, confirmHanlder }) {
  const baseClasses = baseCassConfirm();

  const confirmClick = () => {
    if (typeof confirmHanlder === 'function') {
      confirmHanlder();
    }
  };

  return (
    <Dialog open={open} maxWidth={false}>
      <div className={baseClasses.root}>
        <div className={baseClasses.header} style={{ padding: '1.562rem 0' }}>
          <Typography className={baseClasses.headerTitle}>{i18n.t('BEDSTATUS_TO_AVAILABLE_CONFIRMATION')}</Typography>
          <IconButton id="bed_updatetoavailable_close" className={baseClasses.closeIcon} onClick={closePop}>
            <CloseIcon />
          </IconButton>
        </div>
        <Typography className={baseClasses.areYouSureYouWou}>
          {i18n.t('BEDSTATUS_ARE_YOU_SURE_TO_UPDATE_BED__TO_AVAILABLE', { value: allData?.[P.bedNo] })}
        </Typography>
        <Box display="flex" justifyContent="center" height="5rem" alignItems="center" mt="7rem">
          <ButtonBase
            id="bed_updatetoavailable_cancel"
            className={baseClasses.cancelBtn}
            style={{ marginRight: '1.313rem' }}
            onClick={closePop}
          >
            {i18n.t('BEDSTATUS_CANCEL')}
          </ButtonBase>
          <ButtonBase id="bed_updatetoavailable_confirm" className={baseClasses.configBtn} onClick={confirmClick}>
            {i18n.t('BEDSTATUS_CONFIRM')}
          </ButtonBase>
        </Box>
      </div>
    </Dialog>
  );
}
